module.exports = __webpack_public_path__ + "static/media/logo.ionos.v2.2dd1690f.svg";